import React from "react";
import { connect } from 'react-redux';
import { Button, Select, MenuItem, InputLabel, Grid, Stack, Typography } from "@mui/material";
import StringTranslate from "../../assets/i18n/stringLanguage";
import { ActionSaveSettingsAsk } from '../../redux/actions/settings.js';

import FlagFR from '../../assets/images/flag/FR.svg';
import FlagBE from '../../assets/images/flag/BE.svg';
import FlagGB from '../../assets/images/flag/GB.svg';
import FlagES from '../../assets/images/flag/ES.svg';
import { LanguageHelper } from "../../utils/languageHelper";

import LodashGet from 'lodash/get';

import '../../assets/css/profil.css'

/**
 * Composant permettant de modifier les informations de l'utilisateur
 */
class UserInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: props.email,
            nameExploitation: props.nameExploitation,
            language: props.language,
            touched: false,
            error: false,
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.saveSettings = this.saveSettings.bind(this);
    }

    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState({
            [name]: value,
            touched: true,
            error: false,
        });
    }

    onClickCancelFarmName = () => {
        this.setState({
            editingFarmName: false,
            nameExploitation: this.props.nameExploitation,
            touched: false,
        });
    }

    saveSettings() {
        LanguageHelper.updateLanguage(this.state.language);
        let settingsToSave = {
            ...this.props.settings,
            nameExploitation: this.state.nameExploitation,
            language: this.state.language,
        }

        // ↓ sauvegarde en BDD ↓
        this.props.saveSettings(settingsToSave)
            .then(() => this.setState({
                error: false,
                touched: false,
            }))
            .catch(() => {
                this.setState({
                    error: true,
                    touched: false,
                })
            });
    }

    render() {
        const { email, language, touched, error } = this.state;

        return (
            <Grid container spacing={2} alignItems="center">

                {/* Email utilisateur */}
                <Grid item xs={12}>
                    <Stack spacing={0.25} alignItems="flex-start" sx={{ mb: 3 }}>
                        <Typography variant="caption">{StringTranslate.email}</Typography>
                        <Typography variant="subtitle1">{email}</Typography>
                    </Stack>
                </Grid>

                {/* ↓ partie SELECTION de la langue ↓ */}
                <Grid item xs={12} >
                    <InputLabel>{StringTranslate.language}</InputLabel>
                    <Select
                        value={language}
                        name={'language'}
                        onChange={this.handleInputChange}
                        fullWidth
                        sx={{ mt: 2, mb: 1 }}
                        error={error}
                    >
                        <MenuItem value='fr-FR'> <div><img src={FlagFR} width="18" alt="Fr" />{` - ${StringTranslate.itemMenuLangueFR}`}</div> </MenuItem>
                        <MenuItem value='fr-BE'> <div><img src={FlagBE} width="18" alt="Be" />{` - ${StringTranslate.itemMenuLangueBE}`}</div> </MenuItem>
                        <MenuItem value='en-GB'> <div><img src={FlagGB} width="18" alt="Gb" />{` - ${StringTranslate.itemMenuLangueGB}`}</div> </MenuItem>
                        <MenuItem value='es-ES'> <div><img src={FlagES} width="18" alt="Es" />{` - ${StringTranslate.itemMenuLangueES}`}</div> </MenuItem>
                    </Select>
                </Grid>

                <Grid item xs={12}>
                    <Stack direction="row" spacing={2} justifyContent="flex-end">
                        <Button
                            type="submit"
                            variant="text"
                            color="error"
                            onClick={this.onClickCancelFarmName}
                            disabled={!touched}
                        >
                            {StringTranslate.annuler}
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            onClick={this.saveSettings}
                            disabled={!touched}
                        >
                            {StringTranslate.enregistrer}
                        </Button>
                    </Stack>
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = state => ({
    email: LodashGet(state, 'clientUserData.userDatas.email', ''),
    language: LodashGet(state, 'settingsData.settings.language'),
    settings: LodashGet(state, 'settingsData.settings', {}),
})

const mapDispatchToProps = dispatch => ({
    saveSettings: (settingsToSave) => dispatch(ActionSaveSettingsAsk(settingsToSave)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UserInfo);